import type { Messages } from "../fr";
import { common } from "./common";
import { auth } from "./auth";
import { shell } from "./shell";
import { dashboard } from "./dashboard";
import { leads } from "./leads";
import { reports } from "./reports";
import { settings } from "./settings";
import { api } from "./api";
import { emails } from "./emails";

export const en: Messages = { common, auth, shell, dashboard, leads, reports, settings, api, emails };
